var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_191_779)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58613 15.1855V8.45129C11.9768 9.5762 13.8283 10.6629 16.0181 11.8345C14.212 12.8361 11.9768 13.96 9.58613 15.1855ZM22.9092 5.10207C22.4968 4.55876 21.794 4.13584 21.0457 3.99582C18.8463 3.57816 5.12518 3.57697 2.92698 3.99582C2.32693 4.10831 1.7926 4.38021 1.3336 4.80266C-0.600435 6.59774 0.00559941 16.2242 0.471777 17.7835C0.667809 18.4585 0.921228 18.9452 1.24038 19.2648C1.65157 19.6872 2.21456 19.9781 2.86123 20.1085C4.67214 20.4831 14.0016 20.6925 21.0074 20.1648C21.6529 20.0523 22.2243 19.752 22.6749 19.3116C24.4631 17.5237 24.3412 7.35669 22.9092 5.10207Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_191_779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.0825195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.22b7061ac60be0ae86c1dfe3cd8a2fc4.svg";
export { ForwardRef as ReactComponent };